import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { BusinessComponentService } from './../business-component.service';
import { ClientProject, AddExistingClientProjectRequest, BusinessComponentDetail } from '../models/client-project.model';

import { ClientProjectsDTO } from '../models/business-component-response.model';

@Component({
    selector: 'add-existing-client-proj',
    templateUrl: './add-existing-project.component.html',
    styleUrls: ['./add-existing-project.component.scss']
})

export class AddExistingClientProjDialog implements OnInit, AfterViewInit {
    clientProjects: ClientProject[];
    clientProjectsList: ClientProjectsDTO[];
    projectIdList: number[] = [];
    selectedProjects: ClientProjectsDTO[] = [];
    unassignedProjectList: ClientProjectsDTO[];
    dropdownSettings = {};
    constructor(@Inject(DOCUMENT) private _document: Document, private renderer: Renderer2, private _businessComponentService: BusinessComponentService) {
    }
    @Input() selectedBusinessCompId: number;
    @Input() selectedBusinessCompName: string;
    @Input() engagementId: number;
    @Output() modelClose = new EventEmitter<void>();
    ngOnInit(): void {

        this._businessComponentService.businessComponentsprojects$.subscribe(data => {
            const clientprojts = data.flatMap(x => x.clientProjectsDTOs);
            const businessCompDetail: BusinessComponentDetail[] = data.map(item => ({
                businessComponentId: item.businessComponentId,
                businessComponentName: item.businessComponentName,
                businessComponentQPercentage: item.businessComponentQPercentage,
                businessComponentType: 1,
                bcNumber: null,
                bcType: null,
                isAllocated: false,
                hasQualitativeSurvey: false
            }))


            const project = clientprojts.map(prj => {
                const businessComponent = businessCompDetail.find(x => x.businessComponentId === prj.businessComponentId);
                return {
                    clientProjectId: prj.projectId,
                    clientProjectname: prj.projectName,
                    clientProjectNumber: prj.projectNumber,
                    Description: prj.description,
                    clientProjectType: prj.projectType,
                    projectQPercentage: prj.projectQPercentage,
                    businessComponentDetail: businessCompDetail,
                    allocated: prj.isAllocated,
                    isSelected: false,
                    businessComponentId: businessComponent ? businessComponent.businessComponentId : null,
                    businessComponentQPercentage: businessComponent ? businessComponent.businessComponentQPercentage : null,
                    bcNumber: businessComponent ? businessComponent.bcNumber : null,
                    bcType: businessComponent ? businessComponent.bcType : null,
                    projectSurvey: false,
                    bcSurvey: false
                };
            });
            this.clientProjectsList = [...clientprojts];
            this.clientProjects = [...project];
        });

        this.getFilteredClientProjects();
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'projectId',
            textField: 'projectName',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 5,
            allowSearchFilter: true
        };
    }

    ngAfterViewInit(): void {
        let modalBody = this._document.getElementById('modal-content-body') as HTMLElement;
        if (modalBody) {
            this.renderer.setStyle(modalBody, 'height', '63%');
            this.renderer.setStyle(modalBody, 'width', '35%');
        }
    }

    closeConfimationBox() {
        this.modelClose.emit();
    }

    getFilteredClientProjects() {
        this.unassignedProjectList = this.clientProjectsList.filter(clientProject =>
            clientProject.businessComponentId === 0 || clientProject.businessComponentId === null
        );
    }

    onProjectSelect(item: ClientProjectsDTO): void {
        if (!this.selectedProjects.some(x => x.projectId === item.projectId)) {
            this.selectedProjects.push(item);
        }
        this.getSelectedProjects();
    }

    onProjectDeSelect(item: ClientProjectsDTO): void {
        this.selectedProjects = this.selectedProjects.filter(x => x.projectId !== item.projectId);
        this.projectIdList = [];
        this.getSelectedProjects();
    }

    onProjectSelectAll(items: ClientProjectsDTO[]): void {
        const newItems = items.filter(item =>
            !this.selectedProjects.some(x => x.projectId === item.projectId)
        );
        this.selectedProjects.push(...newItems);
        const projectIdSet = new Set(this.projectIdList);
        newItems.map(item => projectIdSet.add(item.projectId));
        this.projectIdList = Array.from(projectIdSet);
    }

    onProjectDeSelectAll(item: ClientProjectsDTO): void {
        this.selectedProjects = this.selectedProjects.filter(x => x.projectId !== item.projectId);
        this.projectIdList = [];
    }

    getSelectedProjects(): void {
        this.selectedProjects.forEach(x => {
            const isValueExists = this.projectIdList.includes(x.projectId);
            if (!isValueExists) {
                this.projectIdList.push(x.projectId);
            }
        });
    }

    addExistingProjectToBusinessComp(projectIds: number[]) {
        const request: AddExistingClientProjectRequest = {

            engagementId: this.engagementId,
            businessComponentId: this.selectedBusinessCompId,
            projectIds: projectIds
        };
        this._businessComponentService.addExistingClientProjects(request).subscribe();
        this.closeConfimationBox();
    }
}
